import { Card, Grid } from "@mui/material";
import ByzTitleBox from "src/components/core-components/ByzTitleBox";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { GridColDef } from "@mui/x-data-grid";
import { useTranslate } from "src/locales";

interface PreliminaryEvaluationProps {
    columns: GridColDef[];
    rows: any[];
    onRowClick: (params: any) => void;
}

export const PreliminaryEvaluation = ({
    columns,
    rows,
    onRowClick,
}: PreliminaryEvaluationProps) => {
    const { t } = useTranslate();

    return (
        <Card sx={{ marginBottom: "10px", pb: 2 }}>
            <ByzTitleBox title={t("nutritional-risk-score.preliminary-evaluation")} />
            <Grid container sx={{ px: 2 }}>
                <ByzMuiDataGrid
                    columns={columns}
                    rows={rows}
                    getRowId={(row: any) => row.ID || row.id}
                    sx={{ width: "99%", cursor: 'pointer' }}
                    onRowClick={onRowClick}
                    autoHeight
                />
            </Grid>
        </Card>
    );
};
